import styled from '@emotion/styled';
import { Box, BoxProps } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import Slider, { Settings } from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const settings: Settings = {
  dots: false,
  infinite: true,
  lazyLoad: 'progressive',
  draggable: false,
  arrows: false,
  swipeToSlide: false,
  speed: 2000,
  autoplaySpeed: 2000,
  slidesToShow: 5,
  autoplay: true,
  responsive: [
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        speed: 2500,
      },
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 950,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1152,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 9999,
      settings: {
        slidesToShow: 5,
      },
    },
  ],
};

interface Props extends BoxProps {}

const Slide: React.FC<Props> = ({ children, ...restProps }) => (
  <Box height="50px" {...restProps} px="25px">
    {children}
  </Box>
);

const StyledSlider = styled(Slider)`
  .slick-track {
    display: flex;
  }

  .slick-slide {
    div {
      div {
        display: flex !important;
        justify-content: center;
      }
    }
  }
`;

const LogoSlider: React.FC = () => (
  <Box overflow="visible" display="block" width="100%" height="50px" mb={1000}>
    <StyledSlider {...settings}>
      <Slide>
        <StaticImage
          loading="lazy"
          placeholder="blurred"
          width={44}
          height={46}
          objectFit="contain"
          src="../../../assets/images/gaf_logo.png"
          alt="gaf logo"
        />
      </Slide>
      <Slide>
        <StaticImage
          loading="lazy"
          objectFit="contain"
          placeholder="blurred"
          width={73}
          height={37}
          src="../../../assets/images/srs_logo.png"
          alt="srs logo"
        />
      </Slide>
      <Slide pt={200}>
        <StaticImage
          loading="lazy"
          objectFit="contain"
          placeholder="blurred"
          width={170}
          height={35}
          src="../../../assets/images/plygem_logo.png"
          alt="plygem logo"
        />
      </Slide>

      <Slide pb={200}>
        <StaticImage
          loading="lazy"
          placeholder="blurred"
          width={162}
          objectFit="contain"
          height={38}
          src="../../../assets/images/travelers_vector_logo_red.png"
          alt="travelers logo"
        />
      </Slide>
      <Slide>
        <StaticImage
          loading="lazy"
          placeholder="blurred"
          width={37}
          height={37}
          src="../../../assets/images/owens_corning_logo.png"
          alt="owens corning logo"
          objectFit="contain"
        />
      </Slide>
      <Slide>
        <StaticImage
          loading="lazy"
          placeholder="blurred"
          width={190}
          height={40}
          src="../../../assets/images/bacon_roofing_supply_logo.png"
          alt="bacon roofing supply logo"
          objectFit="contain"
        />
      </Slide>
      <Slide>
        <StaticImage
          loading="lazy"
          placeholder="blurred"
          width={170}
          height={23}
          src="../../../assets/images/state_farm_logo_1.png"
          alt="state farm logo"
          objectFit="contain"
        />
      </Slide>
      <Slide>
        <StaticImage
          loading="lazy"
          placeholder="blurred"
          width={87}
          height={40}
          src="../../../assets/images/abc_logo.png"
          alt="abc logo"
          objectFit="contain"
        />
      </Slide>
      <Slide>
        <StaticImage
          loading="lazy"
          placeholder="blurred"
          width={162}
          height={33}
          src="../../../assets/images/james_hardie_logo.png"
          alt="james hardie logo"
          objectFit="contain"
        />
      </Slide>
    </StyledSlider>
  </Box>
);

export default LogoSlider;
